import { render, staticRenderFns } from "./CoPilotPromptsPage.vue?vue&type=template&id=33a483b4&scoped=true"
import script from "./CoPilotPromptsPage.vue?vue&type=script&lang=js"
export * from "./CoPilotPromptsPage.vue?vue&type=script&lang=js"
import style0 from "./CoPilotPromptsPage.vue?vue&type=style&index=0&id=33a483b4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33a483b4",
  null
  
)

export default component.exports